import React from 'react'
import '../css/About.css'
import { GoDotFill } from "react-icons/go";

const About = () => {
    return (
        <div className='about' id='about'>
            <div className='container'>
                <div className='col-2'>
                    {/* <h2>About</h2> */}
                    <span className='line' />

                    
                    <p>
                        Give yourself a competitive edge with stunning 4K photos and videos. Showcase a property's surroundings,
                        features, and neighborhood in a way that is only possible with drone footage.
                    </p>
                    
                    <p>
                        Lee Aerials strives to provide high quality and cost effective solutions for all your aerial film and photo needs.
                        We specialize in HD landscape and real estate footage.
                    </p>
                    <p>
                        Why choose Lee Aerials?
                    </p>
                    <ul className='choose-list'>
                        <li><GoDotFill/>FAA Part 107 Certified</li>
                        <li><GoDotFill/>Gurenteed fast, high-quality footage</li>
                        <li><GoDotFill/>Technical filming and editing experience</li>
                        <li><GoDotFill/>Support local business</li>
                    </ul>
                    {/* <button className='button' href='#pricing'>Get a Quote</button> */}
                </div>
            </div>
        </div>
    )

}

export default About